<template>
<div class="index_content" :style="{backgroundImage: `url(${image})`}">
    <div class="content">
        <navTop></navTop>
        <div class="center_main">
            <div class="center_main_top">
                <div class="tag_main" v-if="activeTag==0">
                    <tagLog :vdata="bottomList" @godata="getTagDAta"></tagLog>
                </div>
                <div class="tag_main" v-if="activeTag==2">
                    <tagFin :vdata="bottomList" @godata="getTagDAta"></tagFin>
                </div>
                <div class="tag_main" v-if="activeTag==4">
                    <tagCom :vdata="bottomList" @godata="getTagDAta"></tagCom>
                </div>
            </div>
            <!-- <div class="center_main_bottom" v-if="isShow">
                <div :class="{'item':item.isText,'item_icon':item.isText==false,'active_tag':item.hasClass}" v-for="(item,index) in bottomList" :key="index" @click="changeTag(item,index)" v-if="(item.isText&&item.isShow)||(item.isText==false&&item.isShow)">{{item.text}}</div>
            </div> -->
        </div>
    </div>

</div>
</template>

<script>
import navTop from '@/components/navTop'
import tagCom from '@/components/tagCom'
import tagFin from '@/components/tagFin'
import tagLog from '@/components/tagLog'
import {ossUrl} from "@/utils/config"
import {
    debounce
} from "@/utils/utils"
export default {
    name: "servesProduct",
    components: {
        navTop,
        tagLog,
        tagFin,
        tagCom
    },
    watch: {
        "vdata"(newvalue) {
            //console.log(newvalue, "2____________")
        },
        "activeTag"(index) {
            if (index == 0) {
               this.image = `${this.ossUrl}/bg_8.png`;
            } else if (index == 2) {
               this.image = `${this.ossUrl}/bg_9.png`;
            } else if (index == 4) {
                this.image = `${this.ossUrl}/bg_10.png`;
            }
        }
    },
    data() {
        return {
             ossUrl:ossUrl,
            tagData: {},
            hasBg: true,
            isShow: true,
            image: "",
            activeTag: 0,
            bottomList: [{
                    id: 0,
                    text: "物流服务",
                    isText: true,
                    isShow: true,
                    hasClass: true,
                },
                {
                    id: 1,
                    text: "",
                    isText: false,
                    isShow: true,
                    hasClass: false,

                },
                {
                    id: 2,
                    text: "金融服务",
                    isText: true,
                    isShow: true,
                    hasClass: false,
                },
                {
                    id: 3,
                    text: "",
                    isText: false,
                    isShow: true,
                    hasClass: false,
                },
                {
                    id: 4,
                    text: "综合服务",
                    isText: true,
                    isShow: true,
                    hasClass: false,
                },
                {
                    id: 5,
                    text: "",
                    isText: false,
                    isShow: true,
                    hasClass: false,
                }
            ]
        }
    },
    methods: {
        handleScroll(e) {
            e = e || window.event;
            let type = null;
            if (e.wheelDelta) { //判断浏览器IE，谷歌滑轮事件
                if (e.wheelDelta > 0) { //当滑轮向上滚动时
                    console.log('向上滚动');
                    type = 'up'
                }
                if (e.wheelDelta < 0) {
                    console.log('向下滚动')
                    type = 'down'
                }
            } else if (e.detail) { //Firefox滑轮事件
                if (e.detail > 0) { //当滑轮向上滚动时
                    console.log('向上滚动')
                    type = 'up'
                }
                if (e.detail < 0) {
                    console.log('向下滚动')
                    type = 'down'
                }
            }
              let arr = this.bottomList;
            if (type == 'down') {
                if (this.activeTag >= 0 && this.activeTag < 4) {
                    this.activeTag += 2;
                } else if (this.activeTag == 4) {
                    this.activeTag = 0;
                } 
            }
            if (type == 'up') {
                if (this.activeTag > 0 && this.activeTag <= 4) {
                    this.activeTag -= 2;
                } else if (this.activeTag == 0) {
                    this.activeTag = 4;
                }
                //console.log(this.activeTag)
            }
            this.changeTag(arr[this.activeTag], this.activeTag);

        },
        getTagDAta(data) {
            //this.isShow=true;
            console.log(data, "2_______22222")
            this.changeTag(data.item, data.index)
            // this.bottomList=data;
            // this.isShow=true;
            //window.location.reload();
        },
        getBg(path) {
            if (path == '/servesProduct') {
                this.image = `${this.ossUrl}/bg_8.png`;
            }
        },
        changeTag(item, index) {
            //console.log(item, index);
            //console.log(index % 2)
            this.bottomList.forEach((item, num) => {
                if (index == num) {

                    this.$set(this.bottomList, num, {
                        id: item.id,
                        text: item.text,
                        isText: item.isText,
                        isShow: item.isShow,
                        hasClass: true,
                    })
                } else {
                    this.$set(this.bottomList, num, {
                        id: item.id,
                        text: item.text,
                        isText: item.isText,
                        isShow: item.isShow,
                        hasClass: false,
                    })
                }
                if (index % 2 == 0 && index == num) {
                    this.activeTag = item.id;

                    //console.log(this.activeTag,"activeTag")
                    this.$set(this.bottomList, num + 1, {
                        id: item.id,
                        text: "",
                        isText: false,
                        isShow: false,
                    })
                } else {

                    //console.log(num, num + 1, this.bottomList.length)
                    if (num % 2 == 0 && num + 1 < 11) {
                        this.$set(this.bottomList, num + 1, {
                            id: item.id,
                            text: "",
                            isText: false,
                            isShow: true
                        })
                    }

                }
            })
            if (index == 10) {
                //console.log(1111111)
                this.$set(this.bottomList, 9, {
                    id: item.id,
                    text: "",
                    isText: false,
                    isShow: false
                })
            }
        }
    },
    created() {
        window.addEventListener('mousewheel', debounce(this.handleScroll), false)
        window.addEventListener('DOMMouseScroll', debounce(this.handleScroll), false)
        console.log(this.$route);
        this.getBg(this.$route.path);
        this.$set(this.bottomList, 1, {
            id: 1,
            text: "",
            isText: false,
            isShow: false,
            hasClass: false,
        });
        //console.log(this.bottomList)

    }
}
</script>

<style lang="less" scoped>
.index_content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-position: center center;
    background-color: #06162F;

}

.center_main {
    display: flex;
    flex: 1;
    flex-direction: column;
    //border: 1px red solid;
    background-size: cover;
    background-repeat: no-repeat;
}

.content {
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;

}

.center_main_bottom {
    //width: 100%;
    height: 20%;
    min-height: 150px !important;
    background: rgba(2, 21, 39, 0.35);
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 240px;

    //border:1px red solid;
    .item {
        //border: 1px red solid;
        height: 116.5%;
        //color: white;
        //padding:0 60px;
        display: flex;
        min-width: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 28px;
        margin-top: -3%;
    }

    .item_icon {
        width: 15px;
        height: 80%;
        margin: 10px;
        background-image: url("../assets/images/icon_2.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
    }
}

.center_main_top {
    width: 100%;
    height: 100%;
    //border:1px red solid;

    .tag_main {
        width: 100%;
        height: 100%;
        //border: 1px green solid;
    }
}

.active_tag {
    background: linear-gradient(180deg, rgba(54, 169, 255, 0.35) 0%, rgba(54, 169, 255, 0.1) 100%);
    border-top: 5px #36A9FF solid;
}
</style>



// WEBPACK FOOTER //
// src/views/servesProduct.vue